import { render, staticRenderFns } from "./xy-modal-container.vue?vue&type=template&id=3e4a055a"
import script from "./xy-modal-container.vue?vue&type=script&lang=js"
export * from "./xy-modal-container.vue?vue&type=script&lang=js"
import style0 from "./xy-modal-container.vue?vue&type=style&index=0&id=3e4a055a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports